<div>
  <rt-divider variant="line" margin-bottom-medium></rt-divider>

  <rt-heading>{{ 'rti.field_mapping.settings.title' | translate }}</rt-heading>
  <div ngPreserveWhitespaces>
    <span
      [innerHTML]="
        'rti.field_mapping.settings.description' | translate: { integrationName: integrationName }
      "
    ></span>

    <a [href]="'rti.field_mapping.settings.learn_more' | translate" target="_blank"
      ><span>{{ 'rti.common.learn_more' | translate }}</span>
    </a>
  </div>

  <div margin-top-medium>
    <rt-spinner *ngIf="formsLoading" variant="small"></rt-spinner>

    <ng-container *ngIf="!formsLoading">
      <div *ngFor="let formConfig of formConfigs; trackBy: trackByIndex">
        <rti-field-mapping-form
          (formConfigDeleted)="handleFormConfigDeletion($event)"
          (formConfigExpanded)="handleFormConfigExpanded($event)"
          (formConfigClosed)="handleFormConfigClosed()"
          [integrationName]="integrationName"
          [integrationKind]="config.kind"
          [formConfig]="formConfig"
          [isEditing]="isFormConfigExpanded(formConfig)"
        ></rti-field-mapping-form>
      </div>

      <div *ngIf="dynamicMode" margin-top>
        <rt-add-new-button
          (click)="openDialog()"
          [text]="'rti.field_mapping.settings.add_template.button' | translate"
          variant="wide"
        >
        </rt-add-new-button>
      </div>
    </ng-container>
  </div>
</div>
